"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _immutable = require("immutable");

var _q = _interopRequireDefault(require("q"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _PlaybookRecord = _interopRequireDefault(require("playbooks-modal/records/PlaybookRecord"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var playbooksURL = 'playbooks/v1/playbooks';
var playbookSubmissionURL = 'playbooks/v1/answers';

function getPlaybook(_ref) {
  var playbookId = _ref.playbookId,
      source = _ref.source;
  return _apiClient.default.get(playbooksURL + "/" + playbookId, {
    query: {
      source: source
    }
  }).then(function (data) {
    return (0, _PlaybookRecord.default)(data);
  });
}

function getSubmission(_ref2) {
  var playbookId = _ref2.playbookId,
      source = _ref2.source,
      sourceId = _ref2.sourceId;

  if (!source || !sourceId) {
    return _q.default.Promise.resolve((0, _immutable.List)());
  }

  return _apiClient.default.get(playbookSubmissionURL, {
    query: {
      playbookId: playbookId,
      objectType: source,
      objectId: sourceId
    }
  }).then(_immutable.fromJS);
}

function transformQuestionResults(results) {
  return results.reduce(function (curQuestionsMap, question) {
    return curQuestionsMap.set(question.id, _QuestionEntityRecord.default.fromApi(question));
  }, (0, _immutable.Map)());
}

function fetchAllPublished(playbookId) {
  return _apiClient.default.get("playbooks/v1/questions/playbook/" + playbookId + "/published").then(transformQuestionResults);
}

function fetchAllLatest(playbookId) {
  return _apiClient.default.get("playbooks/v1/questions/playbook/" + playbookId + "/latest").then(transformQuestionResults);
}

function fetch(_ref3) {
  var playbookId = _ref3.playbookId,
      source = _ref3.source,
      sourceId = _ref3.sourceId,
      isPublished = _ref3.isPublished;
  var fetchQuestionsRequest = isPublished ? fetchAllPublished : fetchAllLatest;
  return _q.default.Promise.all([getPlaybook({
    playbookId: playbookId,
    source: source
  }), getSubmission({
    playbookId: playbookId,
    source: source,
    sourceId: sourceId
  }), fetchQuestionsRequest(playbookId)]).then(function (_ref4) {
    var _ref5 = (0, _slicedToArray2.default)(_ref4, 3),
        playbook = _ref5[0],
        submissions = _ref5[1],
        questions = _ref5[2];

    var questionsWithSubmissions = submissions.reduce(function (questionsMap, submission) {
      if (!questionsMap.has(submission.get('questionId'))) {
        return questionsMap;
      }

      return questionsMap.mergeIn([submission.get('questionId')], {
        note: submission.get('note') || '',
        selected: submission.get('selectedAnswers').toSet()
      });
    }, questions);
    return {
      playbook: playbook,
      questions: questionsWithSubmissions
    };
  });
}